import styled from 'styled-components'

export const Wrapper = styled.section`
  margin: 0px 0px 20px 0px;
  background-color: #fff;
  border-radius: 10px;
  border: none;
  padding: 20px;
`
